import Staff from '@/views/staff/Staff.vue'
import FormStaff from '@/views/staff/FormStaff.vue'
import DetailStaff from '@/views/staff/DetailStaff.vue'
import StaffDetailTabInfo from '@/components/staff/DetailTabStaff.vue'
import StaffDetailTabDemand from '@/components/staff/DetailTabDemand.vue'
import StaffInnerTabDemandActives from '@/components/staff/InnerTabDemandActives.vue'
import StaffInnerTabDemandCompleteds from '@/components/staff/InnerTabDemandCompleteds.vue'
import StaffInnerTabDemandStandby from '@/components/staff/InnerTabDemandStandby.vue'
import StaffDetailTabTimeline from '@/components/staff/DetailTabTimeline.vue'
import demandModalRouter from '@/router/routers/demandModal'

const staffRouter = (vue, beforeEnter) => {
    return [
        {
            beforeEnter: beforeEnter,
            name: 'Staff',
            path: '/juridico',
            meta: {
                breadcrumb: true,
                breadcrumbName: 'Jurídico',
                public: false,
                isEmployee: true,
                layout: 'default'
            },
            component: Staff
        },
        {
            beforeEnter: beforeEnter,
            name: 'CadastrarStaff',
            path: '/juridico/cadastrar',
            meta: {
                requiresAuth: true,
                isEmployee: true,
                breadcrumb: true,
                breadcrumbName: 'Cadastrar Jurídico',
                layout: 'default'
            },
            component: FormStaff
        },
        {
            beforeEnter: beforeEnter,
            name: 'EditarStaff',
            path: '/juridico/editar/:id',
            meta: {
                requiresAuth: true,
                isEmployee: true,
                breadcrumb: true,
                breadcrumbName: 'Editar Jurídico',
                layout: 'default'
            },
            component: FormStaff
        },
        {
            beforeEnter: beforeEnter,
            name: '',
            path: '/juridico/detalhe/:id',
            meta: {
                requiresAuth: true,
                isEmployee: true,
                breadcrumb: true,
                layout: 'default'
            },
            props: true,
            component: DetailStaff,
            children: [
                {
                    beforeEnter: beforeEnter,
                    name: 'StaffDetalheAbaInfo',
                    path: '',
                    meta: {
                        requiresAuth: true,
                        isEmployee: true,
                        layout: 'default'
                    },
                    props: true,
                    component: StaffDetailTabInfo
                },
                {
                    beforeEnter: beforeEnter,
                    name: '',
                    path: '/juridico/detalhe/:id/demandas/ativas',
                    meta: {
                        requiresAuth: true,
                        isEmployee: true,
                        layout: 'default'
                    },
                    props: true,
                    component: StaffDetailTabDemand,
                    children: [
                        {
                            beforeEnter: beforeEnter,
                            name: 'StaffAbaInternaDemandasAtivas',
                            path: '',
                            meta: {
                                requiresAuth: true,
                                isEmployee: true,
                                layout: 'default'
                            },
                            props: true,
                            component: StaffInnerTabDemandActives
                        },
                        {
                            beforeEnter: beforeEnter,
                            name: 'StaffAbaInternaDemandasFinalizadas',
                            path: '/juridico/detalhe/:id/demandas/finalizadas',
                            meta: {
                                requiresAuth: true,
                                isEmployee: true,
                                layout: 'default'
                            },
                            component: StaffInnerTabDemandCompleteds
                        },
                        {
                            beforeEnter: beforeEnter,
                            name: 'StaffAbaInternaDemandasStandby',
                            path: '/juridico/detalhe/:id/demandas/standby',
                            meta: {
                                requiresAuth: true,
                                isEmployee: true,
                                layout: 'default'
                            },
                            component: StaffInnerTabDemandStandby
                        }
                    ]
                },
                {
                    beforeEnter: beforeEnter,
                    name: 'StaffDetalheAbaTimeline',
                    path: '/juridico/detalhe/:id/timeline',
                    meta: {
                        requiresAuth: true,
                        isEmployee: true,
                        layout: 'default'
                    },
                    component: StaffDetailTabTimeline
                },
                demandModalRouter(beforeEnter, 'CadastrarDemandaStaff', ':requesterType/detalhe/:requesterId?/demandas', false),
                demandModalRouter(beforeEnter, 'DetalheDemandaStaff', ':requesterType/detalhe/:requesterId?/demandas', true)
            ]
        }
    ]
}

export default staffRouter
